export default "__VITE_ASSET__b3bb93d7__"